function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(-0.704 -0.5)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M18.138,1.77a2.433,2.433,0,0,0-4.275,0L10.656,7.486l1.425.847,3.206-5.716a.811.811,0,0,1,1.423,0l5.675,10.448-1.1.7,4.4,3.179-.761-5.481-1.139.72L18.143,1.78Z",
  fill: "#383a36"
}), /*#__PURE__*/React.createElement("path", {
  d: "M2.459,25.489l5.71-9.635,1.1.66.634-5.5L5.577,14.3l1.17.7-5.7,9.615-.01.018a2.541,2.541,0,0,0,2.137,3.811H9.588V26.752H3.175A.847.847,0,0,1,2.459,25.489Z",
  fill: "#383a36"
}), /*#__PURE__*/React.createElement("path", {
  d: "M26.331,19.766l3.206,5.716a.847.847,0,0,1-.712,1.27H17.646V25.4l-4.936,2.2,4.936,2.2V28.446H28.825a2.541,2.541,0,0,0,2.137-3.811l-3.206-5.716Z",
  fill: "#383a36"
}));

var SvgRecycleIcon = function SvgRecycleIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30.593,
    height: 29.299,
    viewBox: "0 0 30.593 29.299",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgRecycleIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/recycle-icon.fc2e7340.svg";
export { ForwardRef as ReactComponent };